import { Children } from 'react';
import { AppMobile, getVariantByActionStyle } from '@vfit/shared/data-access';
import { Accordion, ImageDivider, Button } from '@vfit/shared/atoms';
import { purify } from '@vfit/shared/themes';
import { Fade } from 'react-awesome-reveal';
import {
  FaqAccordionWrapper,
  FaqContainer,
  FaqShowMore,
  Text,
  DisclaimerContainer,
  TopText,
  DisclaimerText,
  AccordionText,
} from './faq.style';
import { IFaqWidget } from './faq.models';

const Faq = ({
  faq,
  containerStyle,
  topText,
  divider,
  disclaimer,
  handleButtonClick,
  actionNavigationUrl,
  handleTaggingLink,
}: IFaqWidget) => {
  const [pTopText, pDisclaimer] = purify([topText, disclaimer]);

  return (
    <>
      {pTopText && (
        <Text>
          <TopText dangerouslySetInnerHTML={{ __html: pTopText }} />
        </Text>
      )}
      <FaqContainer style={{ ...containerStyle }}>
        {Children.toArray(
          faq.elements?.map((f) => (
            <FaqAccordionWrapper
              onClick={handleTaggingLink && (() => handleTaggingLink(f?.title || ''))}
            >
              <Accordion
                onShowing={() => f.action?.onClick?.(f)}
                title={f.title || ''}
                iconColor="#e60000"
                iconSize={24}
                content={[
                  <AccordionText
                    dangerouslySetInnerHTML={{ __html: purify([f.description])?.[0] || '' }}
                  />,
                ]}
              />
            </FaqAccordionWrapper>
          ))
        )}
        {faq.showMore?.title && (
          <FaqShowMore>
            <Button
              // handleButtonClick is inhibited to avoid double url opening
              onClick={() => !actionNavigationUrl && handleButtonClick?.()}
              href={actionNavigationUrl}
              target={
                actionNavigationUrl && faq.showMore?.isBlank === 'true' ? '_blank' : undefined
              }
              name={`action_showMore_${faq.showMore?.type}`}
              variant={
                AppMobile.checkIsApp() ? 'mva:alt1' : getVariantByActionStyle(faq.showMore?.style)
              }
            >
              <span className={`${AppMobile.checkIsApp() ? 'capitalize-first' : ''}`}>
                {faq.showMore?.title}
              </span>
            </Button>
          </FaqShowMore>
        )}
      </FaqContainer>
      {pDisclaimer && (
        <DisclaimerContainer>
          <DisclaimerText dangerouslySetInnerHTML={{ __html: pDisclaimer }} />
        </DisclaimerContainer>
      )}
      {divider?.image && (
        <Fade direction="up" triggerOnce>
          <ImageDivider image={divider?.image} alt={divider.text || ''} />
        </Fade>
      )}
    </>
  );
};

export default Faq;

